import SettingsIcon from '@material-ui/icons/Settings';
import ViewListIcon from '@material-ui/icons/ViewList';
import PublishIcon from '@material-ui/icons/Publish';
import TimelineIcon from '@material-ui/icons/Timeline';
import GroupIcon from '@material-ui/icons/Group';
import AssessmentIcon from '@material-ui/icons/Assessment';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import TuneIcon from '@material-ui/icons/Tune';
import GetAppIcon from '@material-ui/icons/GetApp';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import DescriptionIcon from '@material-ui/icons/Description';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import RateReviewIcon from '@material-ui/icons/RateReview';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';

const mainNav = [
    {
        label: "tarifario",
        href: "/webcedenar/principal/",
        idx: 0,
        disabled: false,
        sideNav: [            
            {
                title: 'Cálculo de tarifas',
                icon: <ViewListIcon/>,
                nav: [
                    {
                        label: "Consola de componentes",
                        href: "/webcedenar/principal/consola-componentes",
                    },
                    {
                        label: "Consola de componentes",
                        href: "/webcedenar/principal/consola-componentes-no-regulados",
                    },
                    // {x
                    //     label: "Opción tarifaria",
                    //     href: "/webcedenar/principal/opcion-tarifaria",
                    // },  
                    {
                        label: "Reliquidaciones",
                        href: "/webcedenar/principal/reliquidaciones",
                    }, 
                    {
                        label: "Arbol tarifario",
                        href: "/webcedenar/principal/arbol-tarifario",
                    },        
                    {
                        label: "Cálculo CRPUI y Valor PUI",
                        href: "/webcedenar/principal/calculo-crpui",
                    },
                    {
                        label: "Publicación",
                        href: "/webcedenar/principal/publicar-tarifas",
                    },    
                    {
                        label: "Alumbrado público",
                        href: "/webcedenar/principal/alumbrado-publico",
                    },
                    // {
                    //     label: "Control de publicación",
                    //     href: "/webcedenar/principal/publicacion-tarifas-no-regulados",
                    // } 
                ]
            },
            {
                title: 'Parametrización',
                icon: <SettingsIcon/>,
                nav: [
                    //  {
                    //     label: "Configuración principal",
                    //     href: "/webcedenar/principal/administracion",                        
                    //  },
                    {
                        label: "Mercados",
                        href: "/webcedenar/principal/mercados",
                    },
                    {
                        label: "Mercados",
                        href: "/webcedenar/principal/mercados-no-regulados",
                    },
                    {
                        label: "Contratos de compra",
                        href: "/webcedenar/principal/contratos-compra",
                    },
                    {
                        label: "Contratos de venta",
                        href: "/webcedenar/principal/contratos-venta",
                    },
                    {
                        label: "Actores financieros",
                        href: "/webcedenar/principal/actores-financieros",
                    },
                    {
                        label: "Administración de clientes",
                        href: "/webcedenar/principal/administracion-clientes-no-regulados",
                    },
                    {
                        label: "Metodologías de cálculo",
                        href: "/webcedenar/principal/metodologias-no-regulados",
                    },
                    {
                        label: "Portafolios y subportafolios",
                        href: "/webcedenar/principal/portafolios-no-regulados",
                    },
                    {
                        label: "Contratos",
                        href: "/webcedenar/principal/contratos-no-regulados",
                    },
                    {
                        label: "Contratos por vencer",
                        href: "/webcedenar/principal/contratos-por-vencer-no-regulados",
                    },                    

                ]
            },
            {
                title: 'Insumos',
                icon: <PublishIcon/>,
                nav: [
                    {
                        label: "Archivos",
                        href: "/webcedenar/principal/validacion-archivos",
                    },
                    {
                        label: "Archivos",
                        href: "/webcedenar/principal/validacion-archivos-no-regulados",
                    },
                    {
                        label: "Parámetros",
                        href: "/webcedenar/principal/validacion-parametros",
                    },
                    {
                        label: "Parámetros",
                        href: "/webcedenar/principal/validacion-parametros-no-regulados",
                    },
                    {
                        label: "Insumos para el mes de cálculo",
                        href: "/webcedenar/principal/insumos-mes-de-calculo-no-regulados",
                    },
                ]
            },
            {
                title: 'Reportes',
                icon: <TimelineIcon/>,
                nav: [
                    {
                        label: "SUI",
                        href: "/webcedenar/principal/reportes-sui",
                    }, 
                    {
                        label: "Tendencia de Tarifas",
                        href: "/webcedenar/principal/tendencia-tarifas",
                    },
                    {
                        label: "Informe comercialización",
                        href: "/webcedenar/principal/informe-comercializacion",
                    },
                    {
                        label: "Balance energético",
                        href: "/webcedenar/principal/balance-energetico",
                    },
                    {
                        label: "Balance Portafolios",
                        href: "/webcedenar/principal/balance-portafolio-no-regulados",
                    },   
                ]
            },
            // {
            //     title: 'Componentes',
            //     icon: <ViewListIcon/>,
            //     nav: [
            //         {
            //             label: "Consola de estado",
            //             href: "/webcedenar/principal/consola-componentes",
            //         },                    
            //     ]
            // }
        ]
    },
    {
        label: "facturador",
        href: "/webcedenar/facturador/",
        idx: 1,
        disabled: false,
        sideNav: [   
            {
                title: 'Parametrización',
                icon:  <TuneIcon/>,
                nav: [
                    {
                        label: "Comercializador",
                        href: "/webcedenar/facturador/parametrizacion-comercializador",
                    },
                    {
                        label: "Ciclos",
                        href: "/webcedenar/facturador/parametrizacion-ciclos",
                    },              
                    {
                        label: "Agenda",
                        href: "/webcedenar/facturador/parametrizacion-mensual",
                    },  
                    {
                        label: "Anual",
                        href: "/webcedenar/facturador/parametrizacion-anual",
                    },  
                    {
                        label: "Cuentas bancarias",
                        href: "/webcedenar/facturador/parametrizacion-cuentas-bancarias",
                    },      
                    {
                        label: "Operadores de red",
                        href: "/webcedenar/facturador/parametrizacion-operadores-de-red",
                    },          
                    {
                        label: "Conceptos",
                        href: "/webcedenar/facturador/parametrizacion-conceptos",
                    },  
                    {
                        label: "Alumbrado público",
                        href: "/webcedenar/facturador/parametrizacion-alumbrado-publico",
                    },   
                    {
                        label: "Impuesto de seguridad",
                        href: "/webcedenar/facturador/parametrizacion-impuesto-seguridad",
                    },        
                ]
            }, 
            {
                title: 'Clientes',
                icon:  <GroupIcon/>,
                nav: [
                    {
                        label: "Control principal",
                        href: "/webcedenar/facturador/control-principal-clientes",
                    },
                    
                ]
            }, 
            {
                title: 'Consumos',
                icon:  <AssessmentIcon/>,
                nav: [
                    {
                        label: "Cargar información por ciclos",
                        href: "/webcedenar/facturador/cargar-consumos-ciclo",
                    },       
                    {
                        label: "Información por cliente",
                        href: "/webcedenar/facturador/informacion-consumos-cliente",
                    },
                    {
                        label: "Análisis de Desviación Significativa",
                        href: "/webcedenar/facturador/analisis-desviacion-significativa",
                    }
                ]
            },
            {
                title: 'Cálculo de Ajustes',                
                icon:  <IndeterminateCheckBoxIcon/>,
                nav: [
                    {
                        label: 'Ajustes',
                        href: "/webcedenar/facturador/ajustes",
                    },                                                
                ]
            },
            {
                title: 'Liquidación de consumos',
                icon:  <LocalAtmIcon/>,
                nav: [
                    {
                        label: "Liquidar",
                        href: "/webcedenar/facturador/liquidar-consumos",
                    },                                                     
                ]
            }, 
            {
                title: 'Liquidación de impuestos',
                icon:  <AccountBalanceIcon/>,
                nav: [                   
                    {
                        label: "Alumbrado público",
                        href: "/webcedenar/facturador/liquidar-alumbrado",
                    },    
                    {
                        label: "Impuesto de seguridad",
                        href: "/webcedenar/facturador/liquidar-impuesto-seguridad",
                    },                                                  
                ]
            },
            {
                title: 'Liquidación compensaciones',
                icon:  <FeaturedPlayListIcon/>,
                nav: [                          
                    {
                        label: "Parametrización y cálculo",
                        href: "/webcedenar/facturador/compensaciones",
                    }                    
                ]
            }, 
            {
                title: 'Liquidación otros conceptos/créditos',
                icon:  <FeaturedPlayListIcon/>,
                nav: [                          
                    {
                        label: "Cargar archivos",
                        href: "/webcedenar/facturador/cargar-otros-conceptos",
                    },                                                  
                ]
            }, 
            {
                title: 'Facturación',
                icon:  <ReceiptIcon/>,
                nav: [
                    
                    {
                        label: "Conceptos por cliente",
                        href: "/webcedenar/facturador/conceptos-por-cliente",
                    }, 
                    {
                        label: "Generar facturas",
                        href: "/webcedenar/facturador/generar-facturas",
                    },                     
                    {
                        label: "Asignación Autorizaciones (HES)",
                        href: "/webcedenar/facturador/asignacion-autorizaciones-hes",
                    }                  
                ]
            },
            {
                title: 'Reportes',
                icon:  <DescriptionIcon/>,
                nav: [        
                    {
                        label: "Dashboard Liquidación",
                        href: "/webcedenar/facturador/dashboard-liquidacion",
                    },
                    {
                        label: "Reportes internos",
                        href: "/webcedenar/facturador/reportes-internos",
                    },    
                    {
                        label: "Informes Auditoría",
                        href: "/webcedenar/facturador/informes-auditoria",
                    },    
                    {
                        label: "Reportes SUI",
                        href: "/webcedenar/facturador/reportes-sui",
                    },                                                  
                ]
            },
            // {
            //     title: 'Autogeneradores',
            //     icon:  <AutorenewIcon/>,
            //     nav: [
            //         {
            //             label: "Cargar información",
            //             href: "/webcedenar/facturador/cargar-info-agpe-gd",
            //         }, 
            //         {
            //             label: "Liquidar",
            //             href: "/webcedenar/facturador/liquidar-agpe-dg",
            //         },                   
            //     ]
            // },         
        ]
    },
    {
        label: "Fotovoltaicos",
        href: "/webcedenar/autogeneradores/",
        idx: 2,
        disabled: false,
        sideNav: [            
            {
                title: 'Parametrización',
                icon:  <TuneIcon/>,
                nav: [          
                    {
                        label: "Ciclos",
                        href: "/webcedenar/autogeneradores/parametrizacion-ciclos",
                    },                
                    {
                        label: "Precios pactados",
                        href: "/webcedenar/autogeneradores/parametrizacion-precios-pactados",
                    },                              
                    {
                        label: "Conceptos",
                        href: "/webcedenar/autogeneradores/parametrizacion-conceptos",
                    },   
                    {
                        label: "Causas no lectura",
                        href: "/webcedenar/autogeneradores/parametrizacion-causas-no-lectura",
                    },                             
                ],
            },
            {
                title: 'Usuarios',
                icon:  <GroupIcon/>,
                nav: [
                    {
                        label: "Control principal",
                        href: "/webcedenar/autogeneradores/usuarios",
                    },                                                          
                ]
            }, 
            {
                title: 'Consumos',
                icon:  <AssessmentIcon/>,
                nav: [
                    {
                        label: "Control de archivos",
                        href: "/webcedenar/autogeneradores/control-archivos",
                    },   
                    {
                        label: "Información por cliente",
                        href: "/webcedenar/autogeneradores/consumos-cliente",
                    },                                                      
                ]
            },
            {
                title: 'Liquidación de consumos',
                icon:  <LocalAtmIcon/>,
                nav: [
                    {
                        label: "Liquidar",
                        href: "/webcedenar/autogeneradores/liquidacion-consumos",
                    },                                                     
                ]
            }, 
            {
                title: 'Exportar información',
                icon:  <GetAppIcon/>,
                nav: [
                    {
                        label: "Anexo para usuarios",
                        href: "/webcedenar/autogeneradores/reporte-usuario",
                    },
                    {
                        label: "Archivo plano",
                        href: "/webcedenar/autogeneradores/exportar-liquidacion",
                    },                                                     
                ]
            },
            {
                title: 'Reportes internos',
                icon:  <TimelineIcon/>,
                nav: [
                    {
                        label: "Informe de facturación por archivo",
                        href: "/webcedenar/autogeneradores/informe-facturacion",
                    },
                    {
                        label: "Tendencias",
                        href: "/webcedenar/autogeneradores/tendencia-facturacion",
                    },
                    {
                        label: "Reportes XM",
                        href: "/webcedenar/autogeneradores/reportes-xm",
                    }
                ]
            },
            {
                title: 'Información de energías',
                icon:  <TimelineIcon/>,
                nav: [
                    {
                        label: "Panel principal",
                        href: "/webcedenar/autogeneradores/consultas/panel-principal",
                    },                                                                       
                ]
            },
            {
                title: 'Reportes facturación',
                icon:  <AssessmentIcon/>,
                nav: [
                    {
                        label: "Descargar anexo de factura",
                        href: "/webcedenar/autogeneradores/consultas/descargar-reporte",
                    },                                                                       
                ]
            },
            {
                title: 'Pago de excedentes',
                icon:  <LocalAtmIcon/>,
                nav: [
                    {
                        label: "Estado",
                        href: "/webcedenar/autogeneradores/consultas/estado-pago-excedentes",
                    },                                                                       
                ]
            },
            // {
            //     title: 'Simulación',
            //     icon:  <GetAppIcon/>,
            //     nav: [
            //         {
            //             label: "Estimación de comportamiento",
            //             href: "/webcedenar/autogeneradores/consultas/comportamiento-estimado",
            //         },                                                                       
            //     ]
            // },
        ]
    },
    {
        label: "operativo",
        href: "/webcedenar/tecnico-operativo/",
        idx: 3,
        disabled: false,
        sideNav: [
            {
                title: 'Control de ordenes',
                icon:  <AssignmentIndIcon/>,
                nav: [
                    {
                        label: "Generar orden",
                        href: "/webcedenar/tecnico-operativo/generar-orden",
                    },                    
                ]
            },
            {
                title: 'Documentos - revisiones técnicas',
                icon:  <RateReviewIcon/>,
                nav: [
                    {
                        label: "Acta de oficio",
                        href: "/webcedenar/tecnico-operativo/rev-tecnica-acta-oficio",
                    },
                    // {
                    //     label: "Hoja de vida",
                    //     href: "/webcedenar/tecnico-operativo/opt1nav2",
                    // }
                ]
            },
        ]
    },   

]

export default mainNav